import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { executeQuery } from '../graphql/api';
import { getBrowseStyles } from '../graphql/queries';

const BROWSE_CACHE_KEY = 'vpl_browse_products';
const BROWSE_CACHE_TTL = 600_000; // 10 minutes, matches AppSync resolver TTL

export const fetchAllBrowse = createAsyncThunk(
  'product/fetchAllBrowse',
  async (_, { rejectWithValue }) => {
    try {
      try {
        const cached = sessionStorage.getItem(BROWSE_CACHE_KEY);
        if (cached) {
          const { data, ts } = JSON.parse(cached);
          if (Date.now() - ts < BROWSE_CACHE_TTL) return data;
        }
      } catch {
        // sessionStorage unavailable or corrupted — fall through to GQL
      }
      const result = await executeQuery(getBrowseStyles);
      const data = result.getBrowseStyleProducts;
      try {
        sessionStorage.setItem(BROWSE_CACHE_KEY, JSON.stringify({ data, ts: Date.now() }));
      } catch {
        // quota exceeded or storage blocked — ignore, GQL data still returned
      }
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
  {
    condition: (_, { getState }) => {
      const { product } = getState();
      return !product.products || product.products.length === 0;
    },
  }
);

const initialState = {
  products: [],
  loading: false,
  error: null,
};

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBrowse.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllBrowse.fulfilled, (state, action) => {
        state.loading = false;
        state.products = action.payload;
      })
      .addCase(fetchAllBrowse.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = productSlice.actions;
export default productSlice.reducer;
